import React from "react";
import $ from "jquery";

import "./_favorites_apps.scss";

export const popupFavs = (height, name) => {
	$(".btn-favorites").css({ height: height });
	$(".popup-favorites").css({ animation: `0.3s ${name} both` });
};

function PopupFav(props) {
	const data = loadFavorites();

	function loadFavorites() {
		const groups = props.favorites;
		let newData = [];
		if (groups != null) {
			for (const group of groups) {
				let newItems = [];
				for (const item of group.items) {
					if (!item.disabled) {
						newItems.push(item);
					}
				}
				newData.push({ title: group.title, items: newItems })
			}
		}
		return newData;
	}

	function showItemsGroup(group) {
		if (group.items.length === 0) {
			return (<p style={{ textAlign: "center" }}>Without Items</p>);
		} else {
			return (
				group.items.map((item, key2) => {
					return (
						<a href={item.link} key={key2} style={{ color: props.text }}>
							<li>
								<img
									src={item.icon}
									alt={item.icon}
									width="20"
								/>
								{item.title}
							</li>
						</a>
					)
				})
			);
		}
	}

	/**
	 * TODO
	 * 
	 * NO mostrar los grupos que no tengan items
	 */

	return (
		<div className="popup-favorites" style={{ backgroundColor: props.background, boxShadow: props.shadow }}>
			<ul className="group" style={{ color: props.text }}>
				{(data != null && data.length > 0) ? data.map((group, key) => {
					return (
						<div key={key}>
							<li className="group-name" style={{ borderBottom: "1px solid " + props.text }}>
								{group.title}
							</li>
							<ul className="item">
								{showItemsGroup(group)}
							</ul>
						</div>
					)
				}) : <p style={{ textAlign: "center" }}>Without Groups</p>}
			</ul>
		</div>
	)

}
export default PopupFav;
